var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('iframe',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"src":"https://pilsa.io/conditions.pdf"}},[_c('p',[_vm._v("Your browser does not support iframes.")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }